import React from 'react'
import styled from 'styled-components'
import BaseSkeleton from 'components/Skeleton'
import Separator from '../../../Separator'
import Section from '../../../Section'
import Header, { Title } from '../../../Header'
import Attribute, { AttributeColumns, Label, Value } from '../../../Attribute'

const LayerContainer = styled.div`
  display: flex;
  align-items: center;
`

const Skeleton = styled(BaseSkeleton)`
  margin-right: 12px;
`

const InspectorSkeleton = ({ isPage = false }) => (
  <div data-testid="inspector-skeleton">
    <Section>
      <LayerContainer>
        <Skeleton width="36px" height="36px" />
        <Skeleton width="100px" height="15px" />
      </LayerContainer>
    </Section>
    {!isPage && (
      <>
        <Separator />
        <Section>
          <Header>
            <Title>Artboard</Title>
          </Header>
          <AttributeColumns>
            <Attribute display="block">
              <Label>Width</Label>
              <Value>
                <Skeleton width="40px" height="15px" />
              </Value>
            </Attribute>
            <Attribute display="block">
              <Label>Height</Label>
              <Value>
                <Skeleton width="40px" height="15px" />
              </Value>
            </Attribute>
          </AttributeColumns>
        </Section>
      </>
    )}
  </div>
)

export default InspectorSkeleton
